import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SoftBox from "components/SoftBox";

import LeavePolicy from "../components/LeavePolicy";
import WorkCalender from "../components/workCalender";
import Holiday from "../components/Holiday";

import { useAuth } from "AuthContext";
import { hasPermission } from "permissionUtils";

function Configuration() {
  const { userPermission = [] } = useAuth();
  const [activeItem, setActiveItem] = useState("");

  const sidebarItems = [
    {
      label: "Leave Policy",
      permission: "Settings.LeaveTracker.LeavePolicy",
    },
    {
      label: "Work Calender",
      permission: "Settings.LeaveTracker.WorkCalender",
    },
    {
      label: "Holiday",
      permission: "Settings.LeaveTracker.Holiday",
    },
  ];

  /* ---------------- SET DEFAULT TAB ---------------- */
  useEffect(() => {
    if (activeItem) return;

    const firstAllowed = sidebarItems.find((item) =>
      hasPermission(item.permission, userPermission)
    );

    if (firstAllowed) {
      setActiveItem(firstAllowed.label);
    }
  }, [userPermission, activeItem]);

  return (
    // <DashboardLayout>
      <SoftBox
        display="flex"
        flexDirection="row"
        px={2}
        py={2}
        sx={{ minHeight: "calc(100vh - 120px)" }}
      >
        {/* ================= SIDEBAR ================= */}
        <Box
          sx={{
            width: "180px",
            flexShrink: 0,
            borderRight: "1px solid #e0e0e0",
            pr: 2,
            position: "sticky",
            top: 0,
            alignSelf: "flex-start",
          }}
        >
          {sidebarItems
            .filter((item) =>
              hasPermission(item.permission, userPermission)
            )
            .map((item) => (
              <Box
                key={item.label}
                onClick={() => setActiveItem(item.label)}
                sx={{
                  padding: "12px 16px",
                  marginBottom: "8px",
                  borderRadius: "8px",
                  backgroundColor:
                    activeItem === item.label ? "#ebe9f6" : "transparent",
                  color:
                    activeItem === item.label ? "#3c3f58" : "#555",
                  fontWeight: activeItem === item.label ? "600" : "400",
                  fontSize: "15px",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor:
                      activeItem === item.label
                        ? "#ebe9f6"
                        : "#f5f5f5",
                  },
                }}
              >
                {item.label}
              </Box>
            ))}
        </Box>

        {/* ================= CONTENT ================= */}
        <Box sx={{ flexGrow: 1, pl: 2, minWidth: 0 }}>
          {activeItem === "Leave Policy" &&
            hasPermission(
              "Settings.LeaveTracker.LeavePolicy",
              userPermission
            ) && <LeavePolicy />}

          {activeItem === "Work Calender" &&
            hasPermission(
              "Settings.LeaveTracker.WorkCalender",
              userPermission
            ) && <WorkCalender />}

          {activeItem === "Holiday" &&
            hasPermission(
              "Settings.LeaveTracker.Holiday",
              userPermission
            ) && <Holiday />}
        </Box>
      </SoftBox>
    // </DashboardLayout>
  );
}

export default Configuration;
